import { Component } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";
import { VersionComponent } from "../../utils/version/version.component";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styles: ``,
  imports: [TranslatePipe, VersionComponent],
})
export class FooterComponent {}
